import React, { useReducer } from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import { generalClasses as styles } from '../styles';
import StepsContext from '../../../contexts/stepsContext';
import FormsRegister from './forms';
import Steps from '../../../components/steps';
import { reducerSteps } from '../../../hooks/stepReducer';
import {
  VERIFY_ID,
  REGISTER_TITLE_STEP_2,
  SEARCH_GUEST,
  REGISTER_VISIT,
  REGISTER_VISIT_TITLE
} from '../../../libraries/texts';

const steps = [VERIFY_ID, REGISTER_TITLE_STEP_2, SEARCH_GUEST, REGISTER_VISIT];

const Register = props => {
  const [step, dispatch] = useReducer(reducerSteps, { page: 0 });
  const { classes, history } = props;

  return (
    <Card className={classes.card}>
      <CardHeader title={REGISTER_VISIT_TITLE} />
      <CardContent className={classes.cardContent}>
        <StepsContext.Provider
          value={{
            beforeStep: step.beforeStep,
            dispatch,
            step,
            history
          }}
        >
          <Steps steps={steps} />
          <FormsRegister />
        </StepsContext.Provider>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(Register);
